import axios from 'axios'

export default {
  getStudents ({ commit }, { ordering = ''}) {
    // Additional parameters:
    // (1) school_year_with_unenrolled (accepts SchoolYear.id)
    commit('getStudentsRequest')
    let url = `/api/student/?limit=0`

    if (ordering) {
      url = url + `&ordering=${ordering}`
    }

    return axios
      .get(url)
      .then(function (response) {
        commit('getStudentsSuccess', response.data)
        return response
      })
      .catch(function (error) {
        commit('getStudentsFailure', error)
        throw error
      })
  },

  getStudentsWithUnenrolled ({ commit }, { ordering = '', schoolYear}) {
    // Additional parameters:
    // (1) school_year_with_unenrolled (accepts SchoolYear.id)
    commit('getStudentsWithUnenrolledRequest')
    let url = `/api/student/with-unenrolled-students/?enrollments__school_year=${schoolYear.id}`

    if (ordering) {
      url = url + `&ordering=${ordering}`
    }

    return axios
      .get(url)
      .then(function (response) {
        commit('getStudentsWithUnenrolledSuccess', response.data)
        return response
      })
      .catch(function (error) {
        commit('getStudentsWithUnenrolledFailure', error)
        throw error
      })
  },

  getStudentsByDueMonth ({ commit }, { ordering = '', schoolYear, paymentPlan}) {
    commit('getStudentsByDueMonthRequest')
    let url = `/api/student/students-by-due-month/?enrollments__school_year=${schoolYear.id}&payment_plan=${paymentPlan}`

    if (ordering) {
      url = url + `&ordering=${ordering}`
    }

    return axios
      .get(url)
      .then(function (response) {
        commit('getStudentsByDueMonthSuccess', response.data)
        return response
      })
      .catch(function (error) {
        commit('getStudentsByDueMonthFailure', error)
        throw error
      })
  },


  getStudentById ({ commit }, { id }) {
    commit('getStudentByIdRequest')
    let url = `/api/student/${id}/`
    return axios
      .get(url)
      .then(function (response) {
        commit('getStudentByIdSuccess', response.data)
        return response.data
      })
      .catch(function (error) {
        commit('getStudentByIdFailure', error)
        throw error
      })
  },
  addStudent ({ commit }, student) {
    commit('addStudentRequest')
    let url = `/api/student/`
    return axios
      .post(url, student)
      .then(function (response) {
        commit('addStudentSuccess', response.data)
        return response.data
      })
      .catch(function (error) {
        commit('addStudentFailure', error.response.data)
        throw error.response.data
      })
  },
  updateStudent ({ commit }, student) {
    commit('updateStudentRequest')
    let url = `/api/student/${student.id}/`
    return axios
      .put(url, student)
      .then(function (response) {
        commit('updateStudentSuccess', response.data)
        return response.data
      })
      .catch(function (error) {
        commit('updateStudentFailure', error.response.data)
        throw error.response.data
      })
  }
}
